const getters = {
  isEventContext: (state) => state.eventContext !== null && state.eventContext > 0,

  inProgressList:        (state) => state.control_points.filter(item => item.execution_status === 'in_progress'),
  waitingForApprovalList: (state) => state.control_points.filter(item => item.execution_status === 'waiting_for_approval'),
  inClosureProcessList:  (state) => state.control_points.filter(item => item.execution_status === 'in_closure_process'),

  relatedToMeControlPointsCount: (state) => Object.keys(state.control_points_stats.related_to_me).reduce((sum, key) => (
    sum + state.control_points_stats.related_to_me[key]), 0),
  allControlPointsCount: (state) => Object.keys(state.control_points_stats.all).reduce((sum, key) => (
    sum + state.control_points_stats.all[key]), 0),

  notifications: (state) => [...state.manualNotifications, ...state.automatedNotifications],
};

export default getters;
